import React from 'react';
const testimonials = [{
  name: 'Valentina R.',
  location: 'Milano 🇮🇹',
  quote: 'Mi ha salvato. Ho molte ore settimanali e ora posso concentrarmi sul rapporto con i ragazzi, il lavoro burocratico è già fatto.',
  initials: 'VR'
}, {
  name: 'Riccardo M.',
  location: 'Roma 🇮🇹',
  quote: 'Le lezioni di Educazione Fisica sono strutturate in modo molto professionale. Ottimo investimento.',
  initials: 'RM'
}, {
  name: 'Camilla G.',
  location: 'Torino 🇮🇹',
  quote: "Lo uso soprattutto quando non ho la palestra. Le schede teoriche per l'aula sono fatte benissimo.",
  initials: 'CG'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-173">
      <div className="max-w-6xl mx-auto" data-id="element-174">
        <div className="text-center mb-12 sm:mb-16" data-id="element-175">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-176">
            Cosa dicono i colleghi di Educazione Fisica...
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-177">
            <span className="text-secondary text-lg" data-id="element-178">⭐⭐⭐⭐⭐</span>
            <span className="text-text-sec font-medium" data-id="element-179">
              4.9/5 · +2.000 Insegnanti
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-180">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-main rounded-2xl p-6 border border-border-light shadow-sm flex flex-col" data-id="element-181">
              <div className="flex items-center gap-2 mb-4" data-id="element-182">
                <span className="text-secondary text-sm" data-id="element-183">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="text-text-main text-base leading-relaxed mb-6 flex-grow italic" data-id="element-184">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-185">
                <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-186">
                  {t.initials}
                </div>
                <div data-id="element-187">
                  <p className="text-text-main font-bold text-sm" data-id="element-188">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-189">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}